import React from 'react';
import Link from 'react-router-dom/Link';

export default class ResetPasswordForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.username = '';
		this.loading = false;
		this.errorMessage = '';
	}

	async submit(){
		this.app.startLoadingForm(this);
		try{
			const result = await this.app.http.requestPasswordReset({
				username:this.username,
			});

			this.app.validate(!!result.CodeDeliveryDetails, "There was an requesting a password change. Please try again.");

			this.reset();
			this.app.goToMessagePage({
				title: 'Please check your email',
				body: (<div>An email has been sent to {`${result.CodeDeliveryDetails.Destination}`}. Once you have received your verification code, then <Link to="/change-password-confirmation">click here to change your password</Link>.</div>)
			});
		}catch(e){
			this.app.stopLoadingForm(this, e);
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/ResetPasswordForm.js